import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeaturesRoutingModule } from './features-routing.module';
import { SharedModule } from '../shared/shared.module';
import { FaqSectionModule } from '../components/faq-section/faq-section.module';
import { IconsModule } from '../icons/icons.module';
import { MatDividerModule } from '@angular/material/divider';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

// Container
import { FeatureContainerComponent } from './components/feature-container/feature-container.component';

// Layout Components
import { LayoutComponent } from './components/layout/layout.component';
import { HeaderComponent } from './components/layout/header/header.component';
import { FooterComponent } from './components/layout/footer/footer.component';
import { ToolbarComponent } from './components/layout/toolbar/toolbar.component';
import { BreadcrumbComponent } from './components/layout/breadcrumb/breadcrumb.component';

// Home Components
import { HomeComponent } from './components/home/home.component';
import { BannerComponent } from './components/home/banner/banner.component';
import { ServiceDefinitionCardsComponent } from './components/home/service-definition-cards/service-definition-cards.component';

// Feature Components
import { ServiceDefinitionDetailsComponent } from './components/service-definition-details/service-definition-details.component';
import { EnvironmentDetailsComponent } from './components/environment-details/environment-details.component';
import { EnvironmentMonitoringComponent } from './components/environment-details/environment-monitoring/environment-monitoring.component';
import { EnvironmentReleasePackageComponent } from './components/environment-details/environment-release-package/environment-release-package.component';
import { EnvironmentOverviewComponent } from './components/environment-details/environment-overview-page/environment-overview.component';
import { EnvironmentEndpointsComponent } from './components/environment-details/environment-endpoints/environment-endpoints.component';

@NgModule({
  declarations: [
    // Container
    FeatureContainerComponent,
    // Layout
    LayoutComponent,
    HeaderComponent,
    FooterComponent,
    ToolbarComponent,
    BreadcrumbComponent,
    // Home
    HomeComponent,
    BannerComponent,
    ServiceDefinitionCardsComponent,
    // Features
    ServiceDefinitionDetailsComponent,
    EnvironmentDetailsComponent,
    EnvironmentMonitoringComponent,
    EnvironmentReleasePackageComponent,
    EnvironmentOverviewComponent,
    EnvironmentEndpointsComponent
  ],
  imports: [
    CommonModule,
    FeaturesRoutingModule,
    SharedModule,
    FaqSectionModule,
    IconsModule,
    MatDividerModule,
    NgxSkeletonLoaderModule
  ]
})
export class FeaturesModule { }
